var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_nativeKeys.js
// module id = 4062
// module chunks = 168707334958949